import React from 'react';
import {
  CloseButton,
  MobileOverlay,
  MobileHeader,
  ListBox,
  StyledCloseIcon,
  ListBoxContainer,
  MobileCtaSection,
} from './DropdownListBox.styles';

export type DropdownListBoxProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  isHoverTrigger?: boolean;
  onClose?: React.MouseEventHandler<HTMLDivElement>;
  /** @deprecated Content to be rendered at the top on mobile view of dropdown */
  mobileHeader?: string | React.ReactNode;
  mobileCtaContent?: React.ReactNode;
  mobileOverlay?: boolean;
  width?: string | number;
  align?: string;
  ref?: React.Ref<HTMLDivElement>;
};

const DropdownListBox: React.FC<DropdownListBoxProps> = React.forwardRef<
  HTMLDivElement,
  DropdownListBoxProps
>(
  (
    {
      className,
      isHoverTrigger,
      onClose,
      mobileHeader,
      mobileCtaContent,
      mobileOverlay = false,
      children,
      width = '100%',
      align = 'left',
      ...rest
    },
    ref
  ) => {
    const Wrapper = mobileOverlay ? MobileOverlay : React.Fragment;
    return (
      <Wrapper>
        <ListBoxContainer
          ref={ref}
          className={className}
          width={width}
          align={align}
          isHoverTrigger={isHoverTrigger}
          mobileOverlay={mobileOverlay}
          {...rest}
        >
          {mobileHeader ? <MobileHeader>{mobileHeader}</MobileHeader> : null}
          <CloseButton variant="transparent">
            <StyledCloseIcon onClick={onClose} />
          </CloseButton>
          <ListBox>{children}</ListBox>
          {mobileCtaContent && <MobileCtaSection>{mobileCtaContent}</MobileCtaSection>}
        </ListBoxContainer>
      </Wrapper>
    );
  }
);

export default DropdownListBox;
